import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import Message from '../../../common/message/Message';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_PRIVACY_TITLE,
	ONBOARDING_PRIVACY_DESCRIPTION,
	ONBOARDING_PRIVACY_CTA,
	ONBOARDING_PRIVACY_URL,
	ONBOARDING_PRIVACY_NAME,
	ONBOARDING_TERMS,
	CONDITIONS_URL,
	ONBOARDING_PRIVACY_CONDITIONS,
	ONBOARDING_PRIVACY_LINK,
} from '../../../../constants/TermsAndConditions';
import { ONBOARDING_FINALIZE_NEWSLETTER } from '../../../../constants/Copy';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';

import './RegisterPrivacy.scss';
import { useEvaluateFeatureFlag } from '../../../../hooks/useEvaluateFeatureFlag';
import { FLAG_KEYS, FLAG_VARIANTS } from '../../../../constants/FlagrABTest';
import {
	FEATURE_FLAG_BROWSER_VALUES,
	FEATURE_FLAG_PRIVACY_STEP_NEWSLETTER,
} from '../../../../constants/WebStorage';
import BoxedCheckbox from '../../../common/form/BoxedCheckbox';

const RegisterPrivacy = ({ submitting, handleSubmit }) => {
	const [isNewsletterChecked, setIsNewsletterChecked] = useState(false);
	const { value: variantKey } = useEvaluateFeatureFlag(FLAG_KEYS.PRIVACY_STEP_NEWSLETTER);
	const isVariantWithNewsletter = variantKey === FLAG_VARIANTS.VARIANT_A;

	useEffect(() => {
		if (isVariantWithNewsletter) {
			if (isNewsletterChecked) {
				window.localStorage.setItem(
					FEATURE_FLAG_PRIVACY_STEP_NEWSLETTER,
					isNewsletterChecked && FEATURE_FLAG_BROWSER_VALUES.ON
				);
			} else {
				window.localStorage.removeItem(FEATURE_FLAG_PRIVACY_STEP_NEWSLETTER);
			}
		}
	}, [isNewsletterChecked, isVariantWithNewsletter]);

	return (
		<form method="POST" onSubmit={handleSubmit} className="onboarding-privacy">
			<OnboardingProgress activeStep={2} />
			<Heading className="onboarding-privacy__title">{ONBOARDING_PRIVACY_TITLE}</Heading>
			<p className="onboarding__text onboarding-privacy__text">
				<Message
					message={ONBOARDING_PRIVACY_DESCRIPTION}
					values={{
						conditions: (
							<a className="onboarding__link" target="_blank" href={CONDITIONS_URL}>
								{ONBOARDING_PRIVACY_CONDITIONS}
							</a>
						),
					}}
				/>
			</p>
			<div className="onboarding-privacy__legal">
				<h2 className="onboarding-privacy__legal-title">{ONBOARDING_TERMS.title}</h2>
				<div className="onboarding__text onboarding-privacy__legal-text">
					{ONBOARDING_TERMS.text.map((text, index) => {
						// eslint-disable-next-line react/no-danger
						return <p key={`terms-${index}`} dangerouslySetInnerHTML={{ __html: text }} />;
					})}
				</div>
			</div>
			{isVariantWithNewsletter && (
				<div className="onboarding-newsletter-checkbox" data-test="newsletter-checkbox">
					<BoxedCheckbox
						inputId="nieuwsbriefcheckbox"
						checked={isNewsletterChecked}
						onChange={() => setIsNewsletterChecked(!isNewsletterChecked)}
					>
						{ONBOARDING_FINALIZE_NEWSLETTER}
					</BoxedCheckbox>
				</div>
			)}
			<p className="onboarding__text onboarding-privacy__text">
				<Message
					message={ONBOARDING_PRIVACY_NAME}
					values={{
						privacy: (
							<a className="onboarding__link" target="_blank" href={ONBOARDING_PRIVACY_URL}>
								{ONBOARDING_PRIVACY_LINK}
							</a>
						),
					}}
				/>
			</p>
			<Button testId="privacy-button" loading={submitting} type="submit" onClick={handleSubmit}>
				{ONBOARDING_PRIVACY_CTA}
			</Button>
		</form>
	);
};

RegisterPrivacy.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
	form: 'register',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(RegisterPrivacy);
